import { render } from "./ChuckNorris.vue?vue&type=template&id=3634fab5"
import script from "./ChuckNorris.vue?vue&type=script&lang=js"
export * from "./ChuckNorris.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__